export default "/kiban/_next/static/images/top_red-f4c21092cd1f5d063db04ca794d8b19c.png";